module.exports = __webpack_public_path__ + "img/exit_normal.22e98d66.svg";